import React from 'react';
import { ACCOUNT_ROUTES } from './routes';
import { AccountStackParams } from './types';
import { createStackNavigator } from '@react-navigation/stack';
import { RestaurantAccountScreen } from '@/screens/restaurant/restaurant-account-screen';
import { useDefaultAppTabScreenOptions } from '@/hooks/use-default-app-tab-screen-options';

const Stack = createStackNavigator<AccountStackParams>();

export const AccountStack: React.FC = () => {
  const screenOptions = useDefaultAppTabScreenOptions('screen');

  return (
    <Stack.Navigator
      initialRouteName={ACCOUNT_ROUTES.Base}
      screenOptions={screenOptions}
    >
      <Stack.Screen
        component={RestaurantAccountScreen}
        name={ACCOUNT_ROUTES.Base}
      />
    </Stack.Navigator>
  );
};
